import { RecipientResponse } from '@/modules/Drive/types'
import { PermissionLevel } from '@/modules/Drive/utils/DrivePermission/permission'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Avatar, FormItem, Button } from 'vnetwork-ui'
import { t } from 'i18next'
import { randomAvatarSrc } from '@/utils/function'

interface AccountCardProps {
    recipient: RecipientResponse
    onDirtyChange: (isDirty: boolean, permission_level: PermissionLevel) => void
}

const AccountCard = ({ recipient, onDirtyChange }: AccountCardProps) => {
    const { control, formState, watch, reset, getValues } = useForm({
        defaultValues: {
            share_permission_level: recipient.share_permission_level,
        },
    })
    const share_permission_level = watch('share_permission_level')
    const { isDirty } = formState

    useEffect(() => {
        onDirtyChange(
            isDirty,
            getValues('share_permission_level') as PermissionLevel
        )
    }, [share_permission_level, isDirty])

    const handleCancelChange = () => {
        reset({ share_permission_level: recipient.share_permission_level })
    }

    return (
        <div className="px-4 py-2 hover:bg-gray-50">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <Avatar
                        src={randomAvatarSrc(recipient.recipient_email)}
                        size="medium"
                    />

                    <div className="flex flex-col">
                        <span className="text-gray-900 font-medium text-sm">
                            {recipient.recipient_name}
                        </span>
                        <span className="text-gray-500 text-xs">
                            {recipient.recipient_email}
                        </span>
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    {isDirty && (
                        <Button
                            size="small"
                            variant="text"
                            className="typo text-xs text-blue-600 px-0"
                            onClick={handleCancelChange}
                        >
                            {t('cancel-changes')}
                        </Button>
                    )}
                    <FormItem
                        control={control}
                        name="share_permission_level"
                        type="select"
                        placeholder={t('remove-access')}
                        options={[
                            { label: t('can-edit'), value: 'edit' },
                            { label: t('can-view'), value: 'read' },
                            {
                                label: t('can-view-and-not-download'),
                                value: 'view',
                            },
                        ]}
                        direction="row"
                        className="min-w-0"
                    />
                </div>
            </div>
        </div>
    )
}
export default AccountCard
